import React from 'react';
import { TextString } from '../../../components/Text';
import { Select } from './RemindersStyledInputs';
import { Days, addNumSuffix } from '../engine/SchedularSettingsQueryEngine';

const SchedularSettingsQueryView = props => {
  return (
    <>
      <TextString content="form-builder.reminders.schedular.sendMail" />
      <Select
        data-testid={'schedular-when-' + props.reminderData.id}
        variant="inline"
        value={props.when}
        onChange={props.onWhenChanged}
        options={[
          {
            text: 'form-builder.reminders.schedular.when.option.soon',
            value: 'soon',
            'data-testid': `schedular-when-soon-${props.reminderData.id}`
          },
          {
            text: 'form-builder.reminders.schedular.when.option.day',
            value: 'day',
            'data-testid': `schedular-when-day-${props.reminderData.id}`
          },
          {
            text: 'form-builder.reminders.schedular.when.option.week',
            value: 'week',
            'data-testid': `schedular-when-week-${props.reminderData.id}`
          },
          {
            text: 'form-builder.reminders.schedular.when.option.month',
            value: 'month',
            'data-testid': `schedular-when-month-${props.reminderData.id}`
          }
        ]}
      />
      {props.showOnWeek ? (
        <>
          <TextString content="form-builder.reminders.schedular.on" />
          <Select
            data-testid={'schedular-on-day-of-week-' + props.reminderData.id}
            variant="inline"
            value={props.dayOfWeek}
            onChange={value => props.update({ 'recurrence.dayOfWeek': value })}
            options={Object.entries(Days).map(([key, value]) => ({
              text: value,
              value: key,
              'data-testid': `schedular-on-day-of-week-${key}-${props.reminderData.id}`
            }))}
          />
        </>
      ) : null}
      {props.showOnMonth ? (
        <>
          <TextString content="form-builder.reminders.schedular.onThe" />
          <Select
            data-testid={'schedular-on-day-of-month-' + props.reminderData.id}
            variant="inline"
            value={props.dayOfMonth}
            onChange={props.onDayOfTheWeekSelected}
            options={new Array(31).fill(null).map((c, i) => {
              const fixedI = i + 1;
              return {
                text: addNumSuffix(fixedI),
                value: fixedI + '',
                'data-testid': `schedular-on-day-of-week-${i}-${props.reminderData.id}`
              };
            })}
          />
          <TextString content="form-builder.reminders.schedular.daOfMonth" />
        </>
      ) : null}
      {props.showAt ? (
        <>
          <TextString content="form-builder.reminders.schedular.at" />
          <Select
            data-testid={'schedular-on-day-of-month-' + props.reminderData.id}
            variant="inline"
            value={props.hourOfDay}
            onChange={value => props.update({ 'recurrence.hourOfDay': value })}
            options={[
              {
                text: '12AM GMT',
                value: '0',
                'data-testid': `schedular-at-0-${props.reminderData.id}`
              },
              {
                text: '4AM GMT',
                value: '4',
                'data-testid': `schedular-at-4-${props.reminderData.id}`
              },
              {
                text: '8AM GMT',
                value: '8',
                'data-testid': `schedular-at-8-${props.reminderData.id}`
              },
              {
                text: '12PM GMT',
                value: '12',
                'data-testid': `schedular-at-12-${props.reminderData.id}`
              },
              {
                text: '4PM GMT',
                value: '16',
                'data-testid': `schedular-at-16-${props.reminderData.id}`
              },
              {
                text: '8PM GMT',
                value: '20',
                'data-testid': `schedular-at-20-${props.reminderData.id}`
              }
            ]}
          />
        </>
      ) : null}
    </>
  );
};

export default SchedularSettingsQueryView;
